import React from "react";
import { VStack, Image, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const CoinsCard = ({
  id,
  name,
  image,
  symbol,
  price,
  currencySymbol = "₹",
}) => {
  return (
    <Link to={`/coin/${id}`}>
      <VStack
        width={"52"}
        bgColor={"blue.900"}
        shadow={"lg"}
        padding={"8"}
        borderRadius={"lg"}
        transition={"all 0.5s"}
        margin={"4"}
        css={{
          "&:hover": {
            transform: "scale(1.1)",
            backgroundColor: "blueviolet",
          },
        }}
      >
        <Image
          src={image}
          width={"10"}
          height={"10"}
          objectFit={"contain"}
          alt={"Exchanges"}
        />
        <Heading size={"md"} noOfLines={1} color={"gold"} textTransform={"uppercase"}>
          {symbol}
        </Heading>
        <Text noOfLines={1}>{name}</Text>
        <Text noOfLines={1}>{price ? `${currencySymbol}${price}` : "NA"}</Text>
      </VStack>
    </Link>
  );
};

export default CoinsCard;
